export type {
  AvatarGroupContextValue,
  AvatarGroupContextValues,
  AvatarGroupProps,
  AvatarGroupSlots,
  AvatarGroupState,
  AvatarGroupBaseProps,
  AvatarGroupBaseState,
} from './components/AvatarGroup/index';
export {
  AvatarGroup,
  avatarGroupClassNames,
  defaultAvatarGroupSize,
  renderAvatarGroup_unstable,
  useAvatarGroupContextValues,
  useAvatarGroupStyles_unstable,
  useAvatarGroup_unstable,
  useAvatarGroupBase_unstable,
} from './components/AvatarGroup/index';
